import Content from './Content';

export default {
    install(Vue) {
        Vue.directive('content', Content);
    }
}